// extracted by mini-css-extract-plugin
export default {"container":"containerKlPB_"};